// ** MUI Imports
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// ** Icon Imports
import { Icon } from '@iconify/react'

// ** Third Party Imports
import { useDropzone } from 'react-dropzone'
import { useTranslation } from 'react-i18next'

const FileUploaderSingle = ({title, pp, setPP}) => {
  const { t } = useTranslation()

  // ** Hooks
  const { getRootProps, getInputProps } = useDropzone({
    multiple: false,
    accept: 'image/png, image/jpg, image/gif, image/jpeg',
    onDrop: acceptedFiles => {
      setPP(acceptedFiles.map(file => Object.assign(file))[0])
    }
  })

  const img = pp ? <img key={"profile-picture"} alt={"profile-picture"} style={{width: '100%', borderRadius: '8px'}} className='single-file-image' src={pp} /> : undefined

  return (
    <Box {...getRootProps({ className: 'dropzone' })} sx={{width: '100%', border: 'dashed 1px grey', borderRadius: '8px'}}>
      <input {...getInputProps()} />
      {pp?.length ? (
        img
      ) : (
        <Box sx={{ display: 'flex', textAlign: 'center', alignItems: 'center', flexDirection: 'column' }}>
          <Box
            sx={{
              mb: 0,
              width: 48,
              height: 48,
              display: 'flex',
              borderRadius: 1,
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Icon icon='tabler:upload' fontSize='1.75rem' />
          </Box>
          <Typography variant='h6' sx={{ mb: 1 }}>
           {title}
          </Typography>
          <Typography sx={{ color: 'text.secondary' }}>
           {t('drop-files')}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default FileUploaderSingle
